import { localApi } from "../../lib/localApi";

type QueryChain = {
  select: () => QueryChain;
  insert: (payload: any) => Promise<{ data: any; error: null }>;
  update: (payload: any) => Promise<{ data: any; error: null }>;
  eq: (_field: string, value: any) => QueryChain;
  maybeSingle: () => Promise<{ data: any; error: null }>;
  single: () => Promise<{ data: any; error: null }>;
  order: () => QueryChain;
  limit: () => QueryChain;
};

function createQuery(table: "participants" | "assessments") : QueryChain {
  let filters: Record<string, any> = {};
  const chain: any = {
    select: () => chain,
    order: () => chain,
    limit: () => chain,
    eq: (_field: string, value: any) => {
      filters[_field] = value;
      return chain;
    },
    insert: async (payload: any) => {
      const data: any = table === "participants" ? await localApi.participants.create(payload) : await localApi.assessments.create(payload);
      return { data, error: null as null };
    },
    update: async (payload: any) => {
      const id = filters.id;
      const data: any = table === "participants" ? await localApi.participants.update(id, payload) : await localApi.assessments.update(id, payload);
      return { data, error: null as null };
    },
    maybeSingle: async () => {
      const id = filters.id;
      const rows = table === "participants" ? await localApi.participants.list() : await localApi.assessments.list(id ? `?id=${id}` : "");
      const row: any = id ? rows.find((r: any) => r.id === id) : rows[0];
      return { data: row || null, error: null as null };
    },
    single: async () => {
      const result = await chain.maybeSingle();
      return result;
    },
  };
  return chain;
}

export const supabase: any = {
  auth: {
    getUser: async () => ({ data: { user: { id: "local-user", email: "local@example.com" } } }),
    onAuthStateChange: (cb: any) => {
      cb("SIGNED_IN", { user: { id: "local-user", email: "local@example.com" } });
      return { data: { subscription: { unsubscribe() {} } } };
    },
    signInWithPassword: async (payload: any) => ({ error: null as null, data: await localApi.auth.signInWithPassword(payload) }),
    signUp: async (payload: any) => ({ error: null as null, data: await localApi.auth.signUp(payload) }),
    signOut: async () => ({ error: null as null, data: await localApi.auth.signOut() }),
  },
  rpc: async (fn: string, args: any) => {
    if (fn === "has_role") {
      const result = await localApi.roles(args._user_id, args._role);
      return { data: result.hasRole, error: null as null };
    }
    return { data: null as null, error: new Error("Unknown function") };
  },
  from: (table: "participants" | "assessments") => createQuery(table),
  functions: {
    invoke: async (name: "create-session" | "validate" | "stt" | "evaluate", options: any) => {
      const body = options?.body || {};
      const data =
        name === "create-session" ? await localApi.session(body) :
        name === "validate" ? await localApi.validate(body) :
        name === "stt" ? await localApi.stt(body) :
        await localApi.evaluate(body);
      return { data, error: null as null };
    },
  },
};
